var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1999 4.49497C7.92653 4.22161 7.48331 4.22161 7.20995 4.49497L6.78936 4.91556C6.5162 5.18872 6.51596 5.63152 6.78882 5.90497L10.3816 9.50557C10.6542 9.77881 10.6542 10.2212 10.3816 10.4944L6.78882 14.095C6.51596 14.3685 6.5162 14.8113 6.78936 15.0844L7.20995 15.505C7.48331 15.7784 7.92653 15.7784 8.1999 15.505L13.2099 10.495C13.4833 10.2216 13.4833 9.77839 13.2099 9.50503L8.1999 4.49497Z",
    fill: "#223CDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.bc7085c97cb09740ca268b316932053e.svg";
export { ForwardRef as ReactComponent };